import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Svg from "react-inlinesvg";
import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { cn } from "~/lib/utils";

type AllergenItemProps = {
  label?: string;
  faIcon?: IconDefinition;
  iconImage?: string;
  className?: string;
  iconClassName?: string;
  isHighlighted?: boolean;
};

export const AllergenItem = ({
  label,
  faIcon,
  iconImage,
  className,
  iconClassName,
  isHighlighted = false
}: AllergenItemProps) => {
  return (
    <div
      className={cn(
        "flex h-7 flex-row items-center justify-center gap-1 rounded-md px-1 text-sm font-bold text-kiosk-text-primary",
        {
          "text-red-500": isHighlighted
        },
        className
      )}
    >
      {faIcon ? (
        <FontAwesomeIcon
          icon={faIcon}
          className={cn("size-5 text-inherit", iconClassName)}
          data-testid="allergens-fa-icon"
        />
      ) : null}
      {iconImage ? (
        <Svg
          src={iconImage}
          className={cn("size-5 text-inherit", iconClassName)}
          data-testid="allergens-svg-icon"
        />
      ) : null}
      {label ? (
        <span className="line-clamp-2 text-inherit font-inherit">{label}</span>
      ) : null}
    </div>
  );
};
